export default "__VITE_ASSET__ClIH0FaO__"